// skrypty dla całej strony (małe), i pluginy jquery, które chcemy w build mieć
define(['jquery', 'app/global', 'app/tools', 'shared/cookie-policy', 'shared/cookie-policy-v4', 'app/form-common', 'app/ajax-search'], function ($, global, tools, cookiePolicy, cookiePolicyV4) {

  var tables,
    $goToTop,
    $actionBack,
    $hpBoxAccessItem,
    $header,
    $tooltip,
    $tooltipCurrent,
    stick,
    isTablet,
    $flash,
    browser,
    $loginButton,
    $footerMobileVersion,
    $print,
    $headerTopLogin,
    $showMoreLink;

  function stickMenu($header) {
    stick = false;
    isTablet = tools.isTablet();
    $(window).on('resize.header', function () {
      isTablet = tools.isTablet();
      $(this).triggerHandler('scroll.header');
    }).triggerHandler('resize.header');
    $(window).on('scroll.header', function () {
      var scrollTop = global.cache.$body.scrollTop(),
        stickNew = (scrollTop > 100 && isTablet && !global.cache.$body.hasClass('landing'));
      if (stickNew !== stick) {
        $header[((stickNew) ? 'add' : 'remove') + 'Class']('stick');
        stick = stickNew;
      }
    }).triggerHandler('scroll.header');
  }

  tables = $('.main .text table');
  if (tables.length) {

    // za małe na plugin
    tables.each(function () {
      var $this = $(this),
        parent;
      $this.wrap('<div class="table-wrap"></div>');
      parent = $this.parent();
      $.each(['top', 'left', 'bottom', 'right'], function () {
        parent.append('<div class="table-wrap-' + this + '"></div>');
      });

      $this.find('tbody tr:not(.hidden):odd').addClass('even')
        .end().find('td:last-child, th:last-child').addClass('last-child');

      $this.find('.table-file__link-download-archive').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        global.cache.$body.find('[data-id=' + $(this).attr('href').slice(1) + ']').toggleClass('hidden');
      });

    });

  }

  // polityka cookie
  cookiePolicy();
  cookiePolicyV4();

  // przewijanie do gory
  $goToTop = $('#go-to-top, .scroll-top');
  if ($goToTop.length) {
    $goToTop.on('click', function (e) {
      $('html, body').animate({
        scrollTop: 0
      }, 250);
      e.preventDefault();
    });
  }

  $tooltip = $('.tooltip');
  if ($tooltip.length) {
    $tooltip.on('click.tooltip', function (e) {
      var $this = $(this),
        $body;
      if (!$this.is($tooltipCurrent)) {
        $tooltipCurrent = $this;
        $body = $this.find('.tooltip-content');
        if ($body.length) {
          $body.css('left', -$this.position().left + 60)
            .addClass('shown');
          global.cache.$html.one('click.tooltip', function () {
            $tooltipCurrent = null;
            $body.removeClass('shown');
          });
        }
      }
      e.stopImmediatePropagation();
      e.preventDefault();
    });
    $(window).on('resize.tooltip', function () {
      $tooltip.each(function () {
        var $this = $(this),
          $body = $this.find('.tooltip-content');
        if ($body.length) {
          $body.css('left', -$this.position().left + 60);
        }
      });
    }).triggerHandler('resize.tooltip');
    $tooltip.on('mouseover.tooltip', function () {
      if (!$(this).is($tooltipCurrent)) {
        global.cache.$html.triggerHandler('click.tooltip');
        $(window).triggerHandler('resize.tooltip');
      }
    });
  }

  // przyklejone menu
  $header = $('#top');
  if ($header.length) {
    stickMenu($header);
  }

  $hpBoxAccessItem = $('.hp-box__access-item');
  if ($hpBoxAccessItem.length && !global.desktopSiteOnTablet) {
    $hpBoxAccessItem
      .on('mouseenter', function () {
        $(this).find('.hp-box__access-hover').fadeIn(200);
      })
      .on('mouseleave', function () {
        $(this).find('.hp-box__access-hover').fadeOut();
      });
  }

  //if (!global.cache.$body.is('.home')) {

  // zakładamy, ze nie ma tego na głównej :)

  //mały skrypt i dość popularny, zostaje tu
  $actionBack = $('.action__back');

  if ($actionBack.length && !global.desktopSiteOnTablet) {
    $actionBack.each(function () {
      var $this = $(this),
        cloud = $this.find('.action__back-cloud');
      if (cloud.length) {
        if (global.ie8) {
          $this
            .on('mouseenter', function () {
              cloud.show();
            })
            .on('mouseleave', function () {
              cloud.hide();
            });
        } else {
          $this
            .on('mouseenter', function () {
              cloud.stop(true, true).fadeIn();
            })
            .on('mouseleave', function () {
              cloud.stop(true, true).fadeOut();
            });
        }
      }
    });
  }

  //}

  // takie dziwne customowe listy dodawane przez WYSIWYG
  $('.text ol span.count').closest('ol').addClass('customOrderedList');


  // skip links
  $('.skip-links').on('click', function (e) {
    e.preventDefault();
    global.cache.$main.find('a:first').focus();
  });

  // scroll do klasy plików do pobrania w produkcie
  if (!!location.hash) {

    $(window).on('hashchange', function () {
      var $target = $(location.hash);
      if ($target.length) {

        $target.closest('.accordion__item').addClass('shown').find('.accordion__content').slideDown();
        $('body, html').animate({
          scrollTop: $target.offset().top
        });
      }
    }).triggerHandler('hashchange');
  }

  // iPad i flash
  $flash = $('object');
  if ($flash.length && /iPad/gi.test(navigator.userAgent)) {

    $flash.each(function () {
      var $this = $(this),
        $plug;

      $plug = $('<h2 class="text-center">Twoja przegląrka nie obsługuje technologii flash. Wyświetlenie animacji nie jest możliwe.</h2>');
      $this.wrap($plug).remove();

      $this.replaceWith($plug);
    });
  }

  browser = navigator.userAgent.match(/firefox|chrome|msie/gi);
  if (browser) {
    $.each(browser, function () {
      global.cache.$body.addClass(this.toLowerCase());
    });
  }

  // pojedyncze "klikniecie" na tabletach w element listy mający tylko przycisk więcej
  if (isTablet) {
    var $buttonsCnt = $('.stack-list__buttons');
    $buttonsCnt.each(function () {
      var $this = $(this);

      if ($this.find('.button').length <= 1) {
        $this.closest('.stack-list__inner-wrap').removeClass('stack-list__inner-wrap icon-hover').addClass('stack-list__inner-wrap--tablet');
      }
    });
  }

  if (window.devicePixelRatio > 1 || (window.matchMedia && window.matchMedia("(-webkit-min-device-pixel-ratio: 1.5),(-moz-min-device-pixel-ratio: 1.5),(min-device-pixel-ratio: 1.5)").matches)) {
    var $withLogo = $('img[src*="inteligo-logo.png"]');

    $withLogo.each(function () {
      $(this).attr('src', $withLogo.attr('src').replace('inteligo-logo.png', 'inteligo-logo@2x.png'));
    })
  }

  $footerMobileVersion = $('#footer-mobile-version');
  if (!!$.cookie('inteligoForceDesktop') && $footerMobileVersion.length) {
    $('.sidebar__top-snippets-inner').css('top', 74);
    $footerMobileVersion.removeClass('hidden')
      .find('a').removeClass('hidden').on('click', function (e) {
      if ($.removeCookie('inteligoForceDesktop', {path: '/'})) {
        window.location.reload(true);
      }
      e.preventDefault();
    });
  }

  //remarketing google
  $loginButton = $('#js-header-top-login');
  if ($loginButton.length) {
    $loginButton.on('click', function () {
      global.cache.$body.append('<img height="1" width="1" style="border-style:none;" alt="" src="' +
        $loginButton.data('conversion') + '"/>');
    });
  }

  $print = $('#print');
  if ($print.length) {
    $print.on('click', function (e) {
      window.print();
      e.preventDefault();
    });
  }

  $headerTopLogin = $('.header-top__login');
  if ($headerTopLogin.length) {
    $headerTopLogin.on('click', function() {
      var axel = Math.random() + "";
      var a = axel * 10000000000000;
      $("body").append('<img src="https://ad.doubleclick.net/ddm/activity/src=4337419;type=odson0;cat=odson00e;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=' + a + '?" width="1" height="1" alt=""/>');
    })
  }

  $showMoreLink = $('.js-show-more-link');
  if ($showMoreLink.length) {
    var $showMoreContent = $showMoreLink.parent().find('.js-show-more-content');
    $showMoreLink.on('click', function(e) {
      e.preventDefault();
      $showMoreLink.hide();
      $showMoreContent.show();
    })
  }

});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/app/common.js